import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf608e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"display":"flex","align-content":"center"}
}
const _hoisted_2 = {
  key: 0,
  style: {display:'flex',justifyContent:'space-between',alignItems:'center'}
}
const _hoisted_3 = { style: {textOverflow:'ellipsis',overflow:'hidden',width:'80%'} }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { style: { fontSize:'13px',color:'#AAAAAA'} }
const _hoisted_6 = { style: {display:'flex'} }

import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVModel, useDebounceFn } from '@vueuse/core'
import CosViewInput from '@/components/Antd/CosView/input.vue'
import { getTianyanchaCustomerList as tycCustomerListFbu } from '@/api/gucangSales/customerCenter'
import { getTianyanchaCustomerList as tycCustomerListLbu } from '@/api/yuntuSales/customerCenter'
import { SelectProps } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import CustomerInfoParse from '@/components/customerInfoParse/index.vue'


const __default__ = { name: 'CosInputTianyancha' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    appId: {},
    value: {},
    label: {},
    disabled: { type: Boolean },
    view: { type: Boolean },
    needParse: { type: Boolean }
  },
  emits: ['update:value', 'selectData', 'parseInfo'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const getCustomerMethod = {
  cos_fbu: tycCustomerListFbu,
  cos_lbu: tycCustomerListLbu
}
const props = __props
const customerEnum = ref<any[]>([]) // 客户下拉选择框数据
const searchValue = ref<string>('') // 搜索框值
const emit = __emit
const modelValue = useVModel(props, 'value', emit)
const firstInit = ref(false) // 第一次初始化
const totalPage = ref(0) // 总页数
const queryForm = ref<{
  customerName?: string
  pageNumber: number
  pageSize: number
}>({
  pageNumber: 1,
  pageSize: 5
}) // 分页参数
const placeholderSearch = computed(() => '请输入或选择客户名称')
const changeTrim = () => {
  if (typeof modelValue.value === 'string' && props.value?.trim) {
    modelValue.value = modelValue.value?.trim()
  }
}
const parseCustomerInfo = (parseResult: any) => {
  emit('parseInfo', parseResult)
}
const getCustomerList = () => {
  if (!searchValue.value.trim()) {
    return
  }
  getCustomerMethod[props.appId]({
    ...queryForm.value,
    appId: props.appId,
    customerName: searchValue.value
  }).then(({ data }) => {
    // 分页数据合并
    customerEnum.value = customerEnum.value.concat(data.items || [])
    totalPage.value = data.totalPage

    const findIndex = customerEnum.value.findIndex((item: any) => item.value && item.value === 'more')
    if (findIndex !== -1 && !firstInit.value) customerEnum.value.splice(findIndex, 1)
    if (customerEnum.value.length > 0 && data.totalPage > customerEnum.value.length) {
      customerEnum.value.push({
        label: '更多...',
        value: 'more'
      })
    }
    // 当 disabled 为 false 时,修改 firstInit 状态，否则每次都当作是首次初始化
    if (!props.disabled) firstInit.value = false
  })
}
const highlightMatch = (text: string, keyword: string) => {
  if (!keyword) {
    return text
  }
  const regex = new RegExp(`(${keyword})`, 'gi')
  return text.replace(regex, '<span style="color: #1d4cd2">$1</span>')
}
// watch(modelValue, async (newValue, oldValue) => {
//   if (newValue) {
//     searchValue.value = newValue.trim()
//     customerEnum.value = []
//     queryForm.value.pageNumber = 1
//     await getCustomerList()
//   }
//   // 监听 clear 清空
//   if (newValue == null && oldValue) {
//     customerEnum.value = []
//     searchValue.value = ''
//   }
// }, { immediate: true }
// )
const onSelect: SelectProps['onChange'] = (v: any) => {
  searchValue.value = v.trim()
  customerEnum.value = []
  queryForm.value.pageNumber = 1
  getCustomerList()
  emit('selectData', v)
  emit('update:value', v)
}
const moreAction = () => {
  queryForm.value.pageNumber++
  getCustomerList()
}
const handleSearch = debounce((val: string) => {
  searchValue.value = val.trim()
  customerEnum.value = []
  queryForm.value.pageNumber = 1
  getCustomerList()
}, 500)

return (_ctx: any,_cache: any) => {
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!

  return (_ctx.view)
    ? (_openBlock(), _createBlock(CosViewInput, {
        key: 0,
        value: _unref(modelValue)
      }, null, 8, ["value"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_auto_complete, {
          class: "input",
          placeholder: placeholderSearch.value,
          value: _unref(modelValue),
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
          valueModifiers: { trim: true },
          showSearch: true,
          onSearch: _unref(handleSearch),
          fieldNames: { label: 'customerName', value: 'customerName' },
          "filter-option": false,
          allowClear: "",
          onSelect: onSelect,
          options: customerEnum.value
        }, {
          option: _withCtx((item) => [
            (item.value!=='more')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", {
                      style: { fontWeight: 'bold',fontSize:'15px' },
                      innerHTML: highlightMatch( item.customerName, searchValue.value)
                    }, null, 8, _hoisted_4),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(`法人：${item.legalPersonName} 经营状态：${item.regStatus}`), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (item.cosExists)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          style: _normalizeStyle({
            height:'22px',
            fontSize:'12px',
            lineHeight:'22px',
            backgroundColor:'rgba(223, 68, 59, 0.1)',
            alignItems:'right',
            color:'#df443b',
            borderRadius:'15px',
            paddingLeft:'5px',
            paddingRight:'5px',
            marginRight:'4px',
            textAlign:'center'
          })
                        }, "重复", 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      style: _normalizeStyle({
            height:'22px',
            fontSize:'12px',
            lineHeight:'22px',
            alignItems:'right',
            color:'#1d4cd2',
            backgroundColor:'rgba(29,76,210,0.1)',
            borderRadius:'15px',
            paddingLeft:'5px',
            paddingRight:'5px',
            textAlign:'center'
          })
                    }, " 认证 ", 4)
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.value==='more')
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  onClick: [
                    _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                    moreAction
                  ],
                  style: {paddingTop:'5px',paddingBottom:'5px'}
                }, "更多..."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["placeholder", "value", "onSearch", "options"]),
        (_ctx.needParse)
          ? (_openBlock(), _createBlock(CustomerInfoParse, {
              key: 0,
              onSuccess: parseCustomerInfo
            }))
          : _createCommentVNode("", true)
      ]))
}
}

})